/**
 * Hardcoded for demo
 */
export const ORG_IDS = {
  NEW_LINES_9_MAY: 'org_qJLCsD73dtDGJ95Y',
  NEW_LINES_13_JUNE: 'org_TsBN8ux8PT70kfRd',
  NEW_LINES_27_JUNE: 'org_dIowUnNiPGnhrL7d',
  NEW_LINES_6_AUGUST: 'org_mfWDkUkeyK7D1Hxo',
  NEW_LINES_27_AUGUST: 'org_hGFZAAqSJ8A1tc4M',
  NEW_LINES_3_SEPTEMBER: 'org_lhFpMVXk6i8UO8R5',
  NEW_LINES_26_SEPTEMBER: 'org_7oNoqPxxK6Ykj3lD', // "SAIS [26 September - US/China/Taiwan Simulation]"
  NEW_LINES_INSTITUTE: 'org_djd4J6WdmpeEgx5X', // "Geopolitical Forecasting Platform"
  UTD_17_OCTOBER: 'org_Ic4Qmh7IeJhJniBn',
  UTD_18_JUNE: 'org_6BqwUCnL46HoZpk1',
  CERBERUS: 'org_4A0PoZoA6aYHqWq8',
  DAMAGE_ASSESSMENT: 'org_avQ4zRW6nvagYU8e',
  NEW_OIL_INC: 'org_8jshRLPB1b13QrwI',
  MASS_ATROCITY_MONITOR: 'org_68RB4MSEWyJcHb1v',
  ELECTRO_MECHANICAL_SYSTEM_INC: 'org_xyEVjN0zVm0NU8sg',
  MOD: 'org_GcN7HOyFIYzb3lXd',
  NLI_UAE_Climate_Simulation: 'org_cSvswNZNtFEekGis',
  CENTRAL_ASIA_CENTER: 'org_GCemVqXhnnXmoepo',
  ZF_LIFETEC_DEMO: 'org_eS26Os1iKGoDkQTn',
  ZF_LIFETEC: 'org_pemGqjsRwbEIa2Hg',
  DM_AUTO: 'org_VVQIQThGW1d4b4kD',
  WP_COUNCIL: 'org_xCPYXYHcqQfCqV0Z',
  NLI: 'org_dSOx8MdBPqATwt4U', // NLI - [Aug 28 - Internal UAE Climate Simulation]
  NATO: 'org_AMthtcLL1Gn4NzMj', // OSMA 2026
};

export const EXCLUDE_USER_DATA_ORGANIZATIONS = [ORG_IDS.MOD];

export const organizationsConfig = [
  {
    id: ORG_IDS.NEW_LINES_13_JUNE,
    actionLink: 'https://docs.google.com/spreadsheets/d/11A5f1RzkGPzsXv70sm-8gAYfvGN_B187ijbgCA8XFTU/edit?usp=sharing',
  },
  {
    id: ORG_IDS.NEW_LINES_27_JUNE,
    actionLink: 'https://docs.google.com/spreadsheets/d/1SXD4Y8oCOE9-uGHDiJxzY2PHq5BP4r_0I6-GLR1Dnsw/edit?usp=sharing',
  },
  {
    id: ORG_IDS.NEW_LINES_6_AUGUST,
    actionLink: 'https://docs.google.com/spreadsheets/d/1yJ2zpklFpl4py437cBRzjTxmwGxavnwmMgohMNzdJgs/edit?usp=sharing',
  },
  {
    id: ORG_IDS.NEW_LINES_27_AUGUST,
    actionLink: 'https://docs.google.com/spreadsheets/d/1z4wTGNvr8cF6zV-w_8zwiz74k1sAwaeCuh2Bug9gfas/edit?usp=sharing',
  },
  {
    id: ORG_IDS.NEW_LINES_3_SEPTEMBER,
    actionLink: 'https://docs.google.com/spreadsheets/d/13yXi9U02OdVaPP8tGfl680dRw0F6-Z98zT-55pO1FeE/edit?usp=sharing',
  },
  {
    id: ORG_IDS.NEW_LINES_26_SEPTEMBER,
    actionLink: 'https://docs.google.com/spreadsheets/d/1e51gKDFqQeADz_7cEbpmMmzOBP_3miqW6zs3-u-JwIQ/edit?usp=sharing',
  },
  {
    id: ORG_IDS.UTD_17_OCTOBER,
    actionLink: 'https://docs.google.com/spreadsheets/d/1kofT3BbWbHEnjw1F6nwVNjqoBLmZFlHKFZlLf93XbXU/edit?usp=sharing',
  },
];

export const TRADE_FLOW_FIGMA_LINK =
  'https://www.figma.com/proto/bQ9bzdSdasQV61RluKG068/MVP---SAS?page-id=3888%3A19763&node-id=3888-20450&viewport=286%2C1324%2C0.48&t=tiGZJQTHE9EdLTvg-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=3888%3A20450';
